// @flow

import * as React from 'react';
import Group from 'sail/Group';
import {Caption} from 'sail/Text';
import type {Article} from 'docs/data';
import {XRaySidebarSection} from './XRaySidebarSection';
import {GatedContentSwitchList} from './GatedContentSwitchList';

type FlagsListProps = {|
  article: Article,
|};

const FLAGS_TO_IGNORE = ['use_cached_docs', 'markdoc_show_localized_doc'];

export const FlagsList = ({article}: FlagsListProps) => {
  if (!article.xray || !article.xray.conditions) {
    console.warn('Missing necessary x-ray data. Please contact #docs-product!'); // eslint-disable-line no-console
    return null;
  }

  const conditions = article.xray.conditions;

  const all = [...conditions.inline];

  const flags = all.filter(
    (c) => !FLAGS_TO_IGNORE.includes(c.name) && c.type === 'flag' && c.valid,
  );

  let content;
  if (flags.length === 0) {
    content = <Caption>None</Caption>;
  } else {
    content = (
      <GatedContentSwitchList
        type="flag"
        keys={flags.map((f) => f.name)}
        article={article}
      />
    );
  }

  return (
    <XRaySidebarSection
      title="Inline Flags in Use"
      hint="These are the flags which are referenced in this article. By default, flags are set to true on Stripe machines."
    >
      <Group spacing={4}>{content}</Group>
    </XRaySidebarSection>
  );
};
